Controller.$inject = ['$scope', '$element', '$document', '$timeout'];

function Controller($scope, $element, $document, $timeout) {
    const self = this;

    self.isOpen = false;
    let popperInstance = null;
    let triggerElement = null;
    let popoverElement = null;
    let closeEventUnsubscribe = null;

    self.$onInit = () => {
        self.placement = self.placement || 'bottom-start';
        self.showCloseIcon = self.showCloseIcon !== false;
        self.trigger = self.trigger || 'click';
        self.disabled = self.disabled || false;
        self.appendTo = self.appendTo || 'body';
        self.offset = self.offset || [0, 16];
        self.autoClose = self.autoClose !== false;

        triggerElement = $element[0].querySelector('[hui-popover-trigger]');
        popoverElement = $element[0].querySelector('.hui-popover');
        
        if (triggerElement && self.trigger === 'click') {
            triggerElement.addEventListener('click', self.toggle);
        } else if (triggerElement && self.trigger === 'hover') {
            triggerElement.addEventListener('mouseenter', self.open);
            triggerElement.addEventListener('mouseleave', self.close);
        }
        
        closeEventUnsubscribe = $scope.$on('hui-popover-close', () => {
            self.close();
        });
    };

    self.toggle = () => {
        self.isOpen ? self.close() : self.open();
    };

    self.open = () => {
        if (self.disabled || self.isOpen) return;
        
        self.isOpen = true;
        self.createPopper();
        
        if (self.autoClose) {
            $timeout(() => {
                $document.on('click', self.handleOutsideClick);
                $document.on('keydown', self.handleEscapeKey);
            });
        }
        
        $scope.$evalAsync();
    };

    self.close = function() {
        if (!self.isOpen) return;
        
        self.isOpen = false;
        self.destroyPopper();
        
        if (self.autoClose) {
            $document.off('click', self.handleOutsideClick);
            $document.off('keydown', self.handleEscapeKey);
        }
        
        $scope.$evalAsync();
    };

    self.handleOutsideClick = function(event) {
        if (!event.target || !event.target.nodeType) return;
        
        const isOutsideContainer = !$element[0].contains(event.target);
        const isOutsidePopover = popoverElement && !popoverElement.contains(event.target);
        
        if (isOutsideContainer && isOutsidePopover) {
            self.close();
        }
    };

    self.handleEscapeKey = function(event) {
        if (event.key === 'Escape') {
            self.close();
        }
    };

    self.createPopper = function() {
        if (!popoverElement || !triggerElement) return;

        popoverElement.style.display = 'block';
        popoverElement.style.position = 'absolute';
        popoverElement.style.top = '0px';
        popoverElement.style.left = '0px';

        const hostElm = self.appendTo
            ? document.querySelector(self.appendTo)
            : document.body;

        const options = {
            placement: self.placement,
            removeOnDestroy: true,
            modifiers: {
                offset: {
                    enabled: true,
                    offset: `${self.offset[0]}, ${self.offset[1]}`
                }
            }
        }

        if (self.enableFlip) {
            options.modifiers = {...options.modifiers,
                flip: {
                    enabled: true
                }
            };
        }

        popperInstance = new Popper(triggerElement, popoverElement, options);
        hostElm.appendChild(popoverElement);
    };

    self.destroyPopper = function() {
        if (popperInstance) {
            popperInstance.destroy();
            popperInstance = null;
        }
        
        if (self.appendTo === 'body' && popoverElement?.parentNode === document.body) {
            document.body.removeChild(popoverElement);
        }
    };

    self.$onDestroy = function() {
        if (triggerElement) {
            if (self.trigger === 'click') {
                triggerElement.removeEventListener('click', self.toggle);
            } else if (self.trigger === 'hover') {
                triggerElement.removeEventListener('mouseenter', self.open);
                triggerElement.removeEventListener('mouseleave', self.close);
            }
        }
        
        if (closeEventUnsubscribe) {
            closeEventUnsubscribe();
        }
        
        self.destroyPopper();
        $document.off('click', self.handleOutsideClick);
        $document.off('keydown', self.handleEscapeKey);
    };
}

export function HuiPopover() {
    return {
        restrict: 'E',
        scope: {},
        bindToController: {
            placement: '@',
            showCloseIcon: '<?',
            trigger: '@',
            disabled: '<?',
            appendTo: '@',
            offset: '<?',
            autoClose: '<?',
            enableFlip: '<?',
            popoverContentWidth: '<'
        },
        controller: Controller,
        controllerAs: '$huiPopoverCtrl',
        transclude: {
            trigger: '?huiPopoverTrigger',
            content: '?huiPopoverContent'
        },
        template: `
            <div class="hui-popover-container">
                <div ng-transclude="trigger" hui-popover-trigger></div>
                
                <div class="hui-popover" 
                     ng-class="{ 'show': $huiPopoverCtrl.isOpen }"
                     ng-style="$huiPopoverCtrl.popoverContentWidth ? 
                               {'width': $huiPopoverCtrl.popoverContentWidth + 'px'} : {'max-width': '400px'}"
                     role="tooltip"
                     aria-hidden="{{ !$huiPopoverCtrl.isOpen }}">
                    <div class="hui-popover-inner">
                        <div class="w-100" ng-transclude="content"></div>
                    </div>
                </div>
            </div>
        `
    };
}